module.exports = __webpack_public_path__ + "static/img/ksznn.acc1242.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/ksznn.png
// module id = hH10
// module chunks = 0